import { Requester } from './Requester';

export const GetClientSurveysRequiringAttentionCount = async (clientId: string): Promise<number> => {
    try {
        const response = await Requester<{ attentionCount: number }>({
            // port: '8080',
            path: `organizations/${clientId}/surveys/attention`,
            method: 'GET'
        });

        return 'attentionCount' in response ? (response as { attentionCount: number }).attentionCount : 0;
    } catch (e) {
        console.error('Get client surveys requiring attention count request failed');
        return Promise.reject(e);
    }
};
